import { data } from '../../svg/Schedule/data';
import { makeIcon } from '../makeIcon';

export const Schedule = makeIcon(data, 'schedule', 'Schedule');

export default Schedule;
